/**
 * Price-chart geometry resolved from `--fm-chart-*` tokens. Recharts takes
 * numeric heights and brush sizes; it cannot read a CSS custom property.
 */

const TOKEN_DEFAULTS: Readonly<Record<string, number>> = {
  '--fm-chart-height': 420,
  '--fm-chart-brush-height': 20,
  '--fm-chart-brush-traveller': 8,
  '--fm-chart-max': 720,
};

/** Token px value; the defaults mirror tokens.css for render before the DOM exists. */
function resolveChartToken(tokenName: string): number {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    const value = getComputedStyle(document.documentElement).getPropertyValue(tokenName).trim();
    const parsed = Number.parseInt(value.replace(/px$/, ''), 10);
    if (Number.isFinite(parsed) && parsed > 0) return parsed;
  }
  return TOKEN_DEFAULTS[tokenName];
}

export const CHART_HEIGHT = resolveChartToken('--fm-chart-height');
export const CHART_BRUSH_HEIGHT = resolveChartToken('--fm-chart-brush-height');
export const CHART_BRUSH_TRAVELLER_WIDTH = resolveChartToken('--fm-chart-brush-traveller');
export const CHART_MAX_PLOT_WIDTH = resolveChartToken('--fm-chart-max');
